import { render } from "./Gallery.vue?vue&type=template&id=b807e4dc"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/Gallery.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b807e4dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b807e4dc', __exports__)) {
    api.reload('b807e4dc', __exports__)
  }
  
  module.hot.accept("./Gallery.vue?vue&type=template&id=b807e4dc", () => {
    api.rerender('b807e4dc', render)
  })

}


export default __exports__